import { render } from "./RealtimeReportPage.vue?vue&type=template&id=8bbcb0a6&ts=true"
import script from "./RealtimeReportPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RealtimeReportPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/realtime/RealtimeReportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bbcb0a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bbcb0a6', __exports__)) {
    api.reload('8bbcb0a6', __exports__)
  }
  
  module.hot.accept("./RealtimeReportPage.vue?vue&type=template&id=8bbcb0a6&ts=true", () => {
    api.rerender('8bbcb0a6', render)
  })

}


export default __exports__